import { Link } from 'react-router-dom'

export default function Onboarding() {
  return (
    <div style={{ padding: 'var(--space-8)', maxWidth: 480, margin: '0 auto', textAlign: 'center' }}>
      <h1 style={{ marginBottom: 'var(--space-4)' }}>Welcome to Print Tracker</h1>
      <p style={{ color: 'var(--color-text-muted)', marginBottom: 'var(--space-6)' }}>
        Let&apos;s set up your first printer to get started. You&apos;ll be tracking sales and expenses against this in minutes.
      </p>
      <Link
        to="/settings/printers/new"
        style={{
          display: 'inline-block',
          padding: 'var(--space-3) var(--space-6)',
          background: 'var(--color-primary)',
          color: 'white',
          borderRadius: 'var(--radius-md)',
          fontWeight: 600,
          textDecoration: 'none',
        }}
      >
        Add my first printer
      </Link>
    </div>
  )
}
